import useVuelidate from '@vuelidate/core';
import { minValue, maxValue } from '@vuelidate/validators';
import { TypeCampaignEnum } from '@/types';
import { requiredWithMessage } from '@/helpers/CustomValidator';
import type { FlowOperatorMetadata, ValidationResult } from '@/types/flow-types';
import { canDeleteTrigger } from '@/components/flows/operators/registry';
import Form from './Form.vue';

export interface ScrollPageData {
  percent_scroll: number;
}

export function createDefaultData(data: Partial<ScrollPageData> = {}): ScrollPageData {
  return {
    percent_scroll: data.percent_scroll ?? 10,
  };
}

const ScrollPage: FlowOperatorMetadata<ScrollPageData> = {
  id: 'boxscrollpage',
  kind: 'trigger',
  label: 'flows.operators.scrollPage.label',
  icon: 'fa-arrows-up-down',
  hasConfiguration: true,
  availableIn: [],
  hidden: true,

  incompatibilities: {
    [TypeCampaignEnum.AUTOMATION]: {
      nextOperators: [
        'boxabandonpanier', 'boxquitsite', 'boxperiodiclaunching',
        'boxscrollpage', 'boxstatuscommand', 'boxregisteronsite',
        'boxsubscribetonewsletter', 'boxtag', 'boxlist',
        'boxsendemail', 'boxsendsms', 'boxsendfbmessenger',
        'boxsendpushnotification', 'openemail', 'clicklink',
        'boxvisitpage', 'boxtriggerinternalevent', 'boxsendrcs', 'boxsendwhatsapp',
      ],
    },
  },

  Form,

  defaultData: createDefaultData,

  outputs: () => 1,

  async validate(data: ScrollPageData): Promise<ValidationResult> {
    const rules = {
      percent_scroll: {
        requiredWithMessage: requiredWithMessage(),
        minValue: minValue(10),
        maxValue: maxValue(100),
      },
    };

    const v$ = useVuelidate(rules, data);
    const success = await v$.value.$validate();
    return {
      success,
      validate: v$,
    };
  },

  canBeDeleted(operatorId: string, flow: any): Promise<boolean | string> {
    return canDeleteTrigger(flow, operatorId);
  },
};

export default ScrollPage;
